import React from "react";
import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@material-ui/core";
import { EdgeModulePreview } from "./EdgeModulePreview";



const useStyles = makeStyles(() => ({
  tableHead: {
    background: "#F8F8F8",
  },

  headerCell: {
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: 0.2,
    color: "#7C8499",
    padding: "6px 8px",
    whiteSpace: "nowrap"
  },

  locationCell: {
    minWidth: 10,
    fontWeight: 500,
  },

  input: {
    width: 70,

    "& input": {
      textAlign: "center",
      fontWeight: 600,
    },
  },

  statRow: {
    background: "#F7F5F0",
  },

  statLabel: {
    fontWeight: 700,
    fontStyle: "italic",
  },
}));

export const EdgePreviewAndEditStage = ({
  tableData,
  setTableData,
  onBack,
  onContinue,
}: any) => {

  const pointColors: any = {
    "20": "#7BC96F", // green
    "40": "#F5C242", // yellow
    "60": "#3B82F6", // blue
    "80": "#E5E7EB", // light gray
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const [serialNumbers, setSerialNumbers] =
    React.useState<string[]>([]);

  const [selectedModuleIndex, setSelectedModuleIndex] =
    React.useState(0);

  const [previewModule, setPreviewModule] =
    React.useState<any>(null);

  const selectedModule =
    tableData?.[selectedModuleIndex];

  const positions = Object.entries(
    selectedModule?.locations?.[0]?.outside_edge || {}
  );

  /* UPDATE PREVIEW ONLY WHEN TAB CHANGES */
  // React.useEffect(() => {

  //   if (tableData?.[selectedModuleIndex]) {

  //     setPreviewModule(
  //       JSON.parse(
  //         JSON.stringify(
  //           tableData[selectedModuleIndex]
  //         )
  //       )
  //     );
  //   }

  // }, [selectedModuleIndex]);


  const classes = useStyles();

  const handleThicknessChange = (
    moduleIndex: number,
    locationIndex: number,
    position: string,
    value: string
  ) => {

    const updatedData = [...tableData];

    updatedData[moduleIndex]
      .locations[locationIndex]
      .thickness[position] = Number(value);

    setTableData(updatedData);
  };




  const handleContinue = () => {

    const allSerialNumbers = tableData?.map(
      (module: any) => module.serial_number
    ) || [];

    setSerialNumbers(allSerialNumbers);

    setOpenDialog(true);
  };
  const calculateAverage = (
    locations: any[],
    position: string
  ) => {

    const values = locations.map(
      (loc) => Number(loc.thickness?.[position] || 0)
    );

    const avg =
      values.reduce((a, b) => a + b, 0) / values.length;

    return avg.toFixed(2);
  };

  const calculateStdDev = (
    locations: any[],
    position: string
  ) => {

    const values = locations.map(
      (loc) => Number(loc.thickness?.[position] || 0)
    );

    const avg =
      values.reduce((a, b) => a + b, 0) / values.length;

    const variance =
      values.reduce(
        (acc, value) =>
          acc + Math.pow(value - avg, 2),
        0
      ) / values.length;

    return Math.sqrt(variance).toFixed(2);
  };

  return (
    <>
      <Grid container spacing={3}>

        <Grid item xs={12} md={4}>

          <EdgeModulePreview
            selectedModule={selectedModule}
          />

        </Grid>

        <Grid item xs={12} md={8}>

          <Card style={{ height: 740 }}>

            <CardContent>

              {/* SERIAL NUMBER TABS */}
              <Box
                mb={3}
                display="flex"

                flexWrap="wrap"
              >

                {tableData?.map(
                  (module: any, index: number) => {

                    const isActive =
                      index === selectedModuleIndex;

                    return (
                      <Button
                        key={module.serial_number}
                        variant={
                          isActive
                            ? "contained"
                            : "outlined"
                        }
                        color="primary"
                        onClick={() =>
                          setSelectedModuleIndex(index)
                        }
                        style={{
                          borderRadius: 12,
                          minWidth: 80,
                          margin: 1,
                          fontSize: 14,
                        }}
                      >
                        {module.serial_number}
                      </Button>
                    );
                  }
                )}

              </Box>

              {/* HEADER */}
              <Box
                mb={3}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={5}
              >

                <Typography variant="h5">
                  Module {selectedModule?.serial_number}
                </Typography>

                <Typography
                  style={{
                    letterSpacing: 2,
                    color: "#7C8499",
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  ALL MEASUREMENTS · MM
                </Typography>

              </Box>

              {/* TABLE */}
              <TableContainer component={Paper} style={{
                // overflowX: "hidden",

              }}>
                <Table>

                  <TableHead className={classes.tableHead}>

                    <TableRow>

                      <TableCell
                        className={classes.headerCell}
                      >
                        LOCATION
                      </TableCell>

                      {positions.map(([key, edgeValue]: any) => (
                        <TableCell
                          key={key}
                          align="center"
                          className={classes.headerCell}
                        >
                          {edgeValue}MM
                        </TableCell>
                      ))}

                    </TableRow>

                  </TableHead>

                  <TableBody>

                    {selectedModule?.locations.map(
                      (loc: any, locationIndex: number) => (
                        <TableRow key={loc.location}>

                          {/* LOCATION */}
                          <TableCell
                            className={classes.locationCell}
                          >
                            {loc.location}
                          </TableCell>

                          {/* DYNAMIC POSITIONS */}
                          {positions.map(([key]: any) => (

                            <TableCell
                              key={key}
                              align="center"
                            >

                              {/* THICKNESS INPUT */}
                              <TextField
                                type="number"
                                variant="outlined"
                                size="small"
                                value={
                                  loc.thickness?.[key] ?? ""
                                }
                                className={classes.input}
                                onChange={(e) =>
                                  handleThicknessChange(
                                    selectedModuleIndex,
                                    locationIndex,
                                    key,
                                    e.target.value
                                  )
                                }
                              />


                              {/* <Typography
                                variant="caption"
                                display="block"
                                style={{
                                  marginTop: 6,
                                  color: "#7C8499",
                                }}
                              >
                                Edge: {loc.outside_edge?.[pos]}
                              </Typography> */}

                            </TableCell>

                          ))}

                        </TableRow>
                      )
                    )}
                    {/* AVERAGE ROW */}
                    <TableRow className={classes.statRow}>

                      <TableCell className={classes.statLabel}>
                        Average
                      </TableCell>

                      {positions.map(([key]: any) => (

                        <TableCell
                          key={key}
                          align="center"
                          style={{
                            fontWeight: 700,
                            color: "#0F5F73",
                          }}
                        >
                          {calculateAverage(
                            selectedModule.locations,
                            key
                          )}
                        </TableCell>

                      ))}

                    </TableRow>

                    {/* STANDARD DEVIATION ROW */}
                    <TableRow className={classes.statRow}>

                      <TableCell className={classes.statLabel}>
                        Std Dev (σ)
                      </TableCell>

                      {positions.map(([key]: any) => (

                        <TableCell
                          key={key}
                          align="center"
                          style={{
                            fontWeight: 700,
                            color: "#0F5F73",
                          }}
                        >
                          {calculateStdDev(
                            selectedModule.locations,
                            key
                          )}
                        </TableCell>

                      ))}

                    </TableRow>

                  </TableBody>


                </Table>
              </TableContainer>

            </CardContent>

          </Card>

        </Grid>

      </Grid>

      <Box
        mt={3}
        display="flex"
        // justifyContent="space-between"
        justifyContent="flex-end"
      >
        {/* <Button
          variant="outlined"
          onClick={onBack}
        >
          Back
        </Button> */}

        <Button
          variant="contained"
          color="primary"
          // onClick={onContinue}

          onClick={handleContinue}
        >
          Continue
        </Button>
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Confirmation
        </DialogTitle>

        <DialogContent>

          <Typography gutterBottom>
            You are going to proceed the Edge Pinch values
            for the following serial numbers:
          </Typography>

          <Box mt={2}>
            {serialNumbers.map((serial: string) => (
              <Typography key={serial}>
                • {serial}
              </Typography>
            ))}
          </Box>

          <Box mt={3}>
            <Typography>
              Do you want to continue?
            </Typography>
          </Box>

        </DialogContent>

        <DialogActions>

          <Button
            onClick={() => setOpenDialog(false)}
          >
            Cancel
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setOpenDialog(false);
              onContinue();
            }}
          >
            Yes Continue
          </Button>

        </DialogActions>
      </Dialog>


    </>
  );
};

